module.exports = __webpack_public_path__ + "img/scene-online.cacd41c8.png";